import styled from 'styled-components';

import { theme } from '_constants/theme';
import { ZendeskAPI } from 'react-zendesk';

const { colors } = theme;

const StyledLiveChatTextLink = styled.span`
  color: ${colors.blue[500]};
  text-decoration: underline;
  cursor: pointer;
`;

const LiveChatTextLink = () => {
  const handleChat = () => {
    ZendeskAPI('webWidget', 'show');
    ZendeskAPI('webWidget', 'open');

    ZendeskAPI('webWidget:on', 'close', function () {
      ZendeskAPI('webWidget', 'hide');
    });
  };
  return (
    <StyledLiveChatTextLink onClick={handleChat}>
      LIVE CHAT
    </StyledLiveChatTextLink>
  );
};

export default LiveChatTextLink;
